import { SchedulerQueueStatus } from '@analyzer/client';
import { Box, Chip, CircularProgress, LinearProgress, Paper, Typography } from '@mui/material';
import { useSchedulerStatusQuery } from '../api/scheduler.js';

function QueueProgress({ label, queue }: { label: string; queue: SchedulerQueueStatus }) {
  const scheduled = queue.total - queue.pending;
  const pct = queue.total > 0 ? Math.round((scheduled / queue.total) * 100) : 0;

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="body2" fontWeight="bold">
          {label}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {scheduled.toLocaleString()} / {queue.total.toLocaleString()} &nbsp;({pct}%) &nbsp;·&nbsp;
          {queue.sliceSize}/tick
        </Typography>
      </Box>
      <LinearProgress variant="determinate" value={pct} sx={{ height: 10, borderRadius: 1 }} />
    </Box>
  );
}

export function SchedulerView() {
  const { data: status, isLoading, error } = useSchedulerStatusQuery();

  if (isLoading) return <CircularProgress />;
  if (error) return <Typography color="error">{error.message}</Typography>;
  if (!status) return null;

  return (
    <Paper sx={{ p: 3, maxWidth: 600 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Typography variant="h6">Scheduler</Typography>
        <Chip
          label={status.blocked ? 'Blocked' : 'Active'}
          color={status.blocked ? 'warning' : 'success'}
          size="small"
        />
        <Typography variant="body2" color="text.secondary">
          {status.workers} workers · {status.queueDepth} jobs in queue
        </Typography>
      </Box>

      <QueueProgress label="Web snapshots" queue={status.web} />
      <QueueProgress label="DNS snapshots" queue={status.dns} />
    </Paper>
  );
}
